module.exports = __webpack_public_path__ + "2751b2c2b4d606c873f9041e6829155c.jpg";